module.exports = __webpack_public_path__ + "img/bz22.eec6e1eb.svg";